import createReducer from '../../createReducer';
import {
  updatePayment,
  addPayment,
  removePayment,
  setPayments,
  placeOrderResult,
  setCheckoutType,
  resetOrderResult,
  indicateWaitingForResponseFromServer,
  selectSinglePaymentMethod,
  clearSinglePaymentMethod,
  setCashierInitializing,
  setPendingPayment,
} from '../actions/CheckoutActions';
import { insertItem, removeItem, replaceItem } from '../../../utils/reducerUtils';
import { CheckoutTypes } from '../../../utils/constants';
import { getPaymentsWithUpdatedAmount } from '../../../utils/CheckoutUtils';
import { clearCustomerSession } from '../actions/SessionActions';

const PLACE_ORDER_RESULT_INITIAL = {
  error: null,
  orderInfo: null,
};
const initialState = {
  payments: [],
  placeOrderResult: PLACE_ORDER_RESULT_INITIAL,
  checkoutType: CheckoutTypes.MANUALLY,
  isWaitingForResponseFromServer: false,
  singlePaymentMethod: '',
};

const newCustomerState = initialState;

const handlers = {
  [removePayment]: (state, payload) => {
    return {
      ...state,
      payments: removeItem(state.payments, payload.paymentIndex),
    };
  },
  [addPayment]: (state, payload) => {
    return {
      ...state,
      payments: insertItem(state.payments, state.payments.length, payload.paymentValue),
    };
  },
  [updatePayment]: (state, payload) => {
    const { checkoutType } = state;
    const payments = replaceItem(state.payments, payload.paymentIndex, payload.paymentValue);
    const paymentsWithUpdatedAmount = getPaymentsWithUpdatedAmount(payments, checkoutType);
    return {
      ...state,
      payments: paymentsWithUpdatedAmount,
    };
  },
  [setPayments]: (state, payload) => {
    const { checkoutType } = state;
    const payments = getPaymentsWithUpdatedAmount(payload.paymentsValue, checkoutType);
    return {
      ...state,
      payments,
    };
  },
  [placeOrderResult]: (state, payload) => {
    return {
      ...state,
      placeOrderResult: payload,
    };
  },
  [setCheckoutType]: (state, payload) => {
    const { checkoutType } = payload;
    const payments = getPaymentsWithUpdatedAmount(state.payments, checkoutType);
    return {
      ...state,
      checkoutType,
      payments,
    };
  },

  [resetOrderResult]: state => {
    return {
      ...state,
      placeOrderResult: PLACE_ORDER_RESULT_INITIAL,
    };
  },

  [clearCustomerSession]: () => {
    return newCustomerState;
  },

  [indicateWaitingForResponseFromServer]: (state, payload) => {
    const { isWaitingForResponseFromServer } = payload;

    return {
      ...state,
      isWaitingForResponseFromServer,
    };
  },

  [selectSinglePaymentMethod]: (state, payload) => {
    const { singlePaymentMethod } = payload;

    return {
      ...state,
      singlePaymentMethod,
    };
  },

  [clearSinglePaymentMethod]: state => {
    return {
      ...state,
      singlePaymentMethod: '',
    };
  },

  [setCashierInitializing]: (state, payload) => {
    const { isCashierInitializing } = payload;

    return {
      ...state,
      isCashierInitializing,
    };
  },

  [setPendingPayment]: (state, payload) => {
    const { hasPendingPayment } = payload;

    return {
      ...state,
      hasPendingPayment,
    };
  },
};

export default createReducer(initialState, handlers);
